<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.showPositions" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="showPositions" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="6" md24 />
      <flex-col :span="12" md24>
        <chessboard @click="loadBoard" @change="onChange" v-if="board" piece-size="2.8em" :show-positions="showPositions" :home="board.home" :away="board.away" />
      </flex-col>
      <flex-col :span="6" md24 />
    </flex>
    <reactive-style>
    .bcq-loading-overlay
    {
      display: none;
    }
    </reactive-style>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageChessboard',
  mixins: [
    methods
  ],
  data () {
    return {
      board: null,
      nextBoard: 0,
      showPositions: true
    }
  },
  mounted () {
    this.loadBoard()
  },
  methods: {
    loadBoard () {
      this.getExternalData(`chessboard-${this.nextBoard}.json`, 'board', 'GET', () => {
        this.nextBoard++
        if (this.nextBoard === 4) {
          this.nextBoard = 0
        }
      })
    },
    onChange ($event) {
      this.log('change', 'chessboard', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/chessboard.vue